import * as yandexMapProvider from './ts/yandexMapProvider';
import * as locationService from './ts/locationService';
import * as numberScrollProvider from './ts/numberScrollProvider';
import * as expandableTextProvider from './ts/expandableTextProvider';
import * as maskTextFieldProvider from './ts/maskTextFieldProvider';
import * as externalNavigationService from './ts/externalNavigationService';
import * as sliderProvider from './ts/sliderProvider';
window['dvizhUi'] = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, window['dvizhUi']), yandexMapProvider), locationService), numberScrollProvider), expandableTextProvider), maskTextFieldProvider), externalNavigationService), sliderProvider);
